import { Component, inject } from '@angular/core';
import { PackService } from '../../services/pack.service';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Pack, PackSizeConfig } from 'src/app/shared/model/pack';

@Component({
  selector: 'app-manage-pack',
  imports: [
    ButtonModule,
    TableModule,
    TooltipModule,
    CommonModule,
    RouterLink,
  ],
  templateUrl: './manage-packs.component.html',
})
export class ManagePacksComponent {
  packService = inject(PackService);

  rangeLabel(
    pack: Pack,
    field: 'tripLimit' | 'userLimit' | 'bulkUpload',
  ): string {
    const values = (pack.packSizeConfig ?? []).map((c) => c[field]);
    if (values.length === 0) return '—';
    const min = Math.min(...values);
    const max = Math.max(...values);
    return min === max ? `${min}` : `${min}–${max}`;
  }

  breakdownTooltip(
    pack: Pack,
    field: 'tripLimit' | 'userLimit' | 'bulkUpload',
  ): string {
    const configs = pack.packSizeConfig ?? [];
    if (configs.length === 0) return '';
    return configs
      .map((c: PackSizeConfig) => `${c.companySize ?? 'default'}: ${c[field]}`)
      .join('\n');
  }
}
